import { useQuery } from '@apollo/client';

import OrderSummaryPage from '../../components/payments/OrderSummaryPage';
import { PURCHASED_INSIGHT_QUERY } from '../../queries';
import Button from '../../components/inputs/Button';
import ErrorText from '../../components/ErrorText';
import { useEffect } from 'react';

function OrderLabel({ order }) {
  return null;
}

function OrderDetails({ order }) {
  const name = order.seedFileName || order.audienceName;
  return (
    <div className="mb-14">
      <h4 className="mb-2 text-xl font-bold">Profile Report Summary</h4>
      <div className="space-y-2">
        <p className="text-lg">
          {order.seedFileName ? 'Seed File Name' : 'Audience Name'}:{' '}
          <span className="font-bold">{name}</span>
        </p>
        <p className="text-lg">
          Order ID: <span className="font-bold">{order.id}</span>
        </p>
        <p className="text-lg">
          # of Records:{' '}
          <span className="font-bold">
            {order?.recordsIncluded?.toLocaleString()}
          </span>
        </p>
      </div>
    </div>
  );
}

function DownloadInsightButton({ packageId, onDownloadStarted }) {
  const { loading, error, data, startPolling, stopPolling } = useQuery(
    PURCHASED_INSIGHT_QUERY,
    {
      variables: {
        packageId,
      },
      fetchPolicy: 'no-cache',
    }
  );

  useEffect(() => {
    startPolling(1000);
  }, []);

  useEffect(() => {
    if (error || data?.purchasedInsight?.downloadLink) {
      stopPolling();
    }
  }, [error]);

  if (loading || data?.purchasedInsight?.downloadLink === null)
    return (
      <div className="relative">
        <Button type="button" disabled className="min-w-max animate-pulse">
          Retrieving your download...
        </Button>
        <div className="absolute mt-1 left-0 right-0">
          <p className="text-sm -ml-3 text-center text-gray-500">
            Hang tight, this can take a minute.
          </p>
        </div>
      </div>
    );

  if (error)
    return (
      <div className="relative">
        <Button type="button" disabled className="min-w-max">
          Download Report
        </Button>
        <div className="absolute mt-1">
          <ErrorText
            message="Failed to retrieve your download."
            className="w-64 text-sm"
          />
        </div>
      </div>
    );

  return (
    <>
      {data?.purchasedInsight && (
        <div className="relative">
          <a
            href={data?.purchasedInsight?.downloadLink}
            download
            onClick={onDownloadStarted}
          >
            <Button type="button" primary className="min-w-max">
              Download Report
            </Button>
          </a>
          <div className="absolute mt-1 left-0 right-0">
            <p className="text-sm -ml-2 text-center">
              Make sure to enable editing in Excel to see your report populate!
            </p>
          </div>
        </div>
      )}
    </>
  );
}

export default function InsightOrderSummary() {
  return (
    <OrderSummaryPage
      OrderLabel={OrderLabel}
      OrderDetails={OrderDetails}
      DownloadButton={DownloadInsightButton}
      title="Success!"
      description="Your audience insights are on their way. Once ready, you can access your report below or find it anytime in the My Work module."
      hideOrderId={true}
      hideThankYou={true}
    />
  );
}
